var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-master"}},[_c('AppNavigation'),_c('div',{attrs:{"id":"page"}},[_c('main',[_c('router-view')],1)]),_c('MasterFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }